<div class="modal-header">
    <h2
        class="modal-title"
        id="exampleModalLabel">
        Manage lanes
    </h2>
    <span></span>
    <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <div class="table__overflow">
        <table
            cdkDropList
            mat-table
            [dataSource]="lanes"
            matSort
            (cdkDropListDropped)="drop($event)">
            <ng-container matColumnDef="lane name">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header>
                    Lane name
                </th>
                <td 
                    mat-cell
                    *matCellDef="let lane"
                    cdkDragHandle>
                    <span [ngStyle]="{display: 'flex', 'align-items': 'center'}">
                        <i class="las la-braille"></i> &nbsp; <app-pill-colored-string [label]="lane.name" [color]="lane.color"></app-pill-colored-string>
                    </span>
                    
                </td>
            </ng-container>

            <ng-container matColumnDef="probability">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header>
                    Probability
                </th>
                <td
                    mat-cell
                    *matCellDef="let lane">
                    {{ lane.probability }}%
                </td>
            </ng-container>

            <ng-container matColumnDef="rotting days">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header>
                    Rotting days
                </th>
                <td
                    mat-cell
                    *matCellDef="let lane">
                    {{ lane.rottingIn }} days
                </td>
            </ng-container>

            <ng-container matColumnDef="lane type">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header>
                    Lanetype
                </th>
                <td
                    mat-cell
                    *matCellDef="let lane">
                    <span
                        *ngIf="lane.type === 'NORMAL'"
                        class="tag tag--success"
                        >Normal</span
                    >
                    <span
                        *ngIf="lane.type === 'WIN'"
                        class="tag tag--green"
                        >Win</span
                    >
                    <span
                        *ngIf="lane.type === 'LOSS'"
                        class="tag tag--danger"
                        >Lost</span
                    >
                </td>
            </ng-container>

            <ng-container matColumnDef="edit">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="td-small"></th>
                <td
                    mat-cell
                    *matCellDef="let lane"
                    class="td-small">
                    <div
                        ngbDropdown
                        class="dropdown"
                        *appIsPermitted="{
                            module: 'PARTNERS',
                            operator: 'OR',
                            actions: ['EDIT', 'DELETE']
                        }">
                        <button
                            ngbDropdownToggle
                            class="button button--icon button--small dropdown-toggle"
                            id="dropdownMenuButton"></button>
                        <div
                            ngbDropdownMenu
                            class="dropdown-menu dropdown-menu-right"
                            aria-labelledby="dropdownMenuButton">
                            <a
                                class="dropdown-item"
                                *appIsPermitted="{
                                    module: 'PARTNERS',
                                    operator: 'AND',
                                    actions: ['EDIT']
                                }"
                                (click)="openAddLaneModal(lane)"
                                >Edit lane</a
                            >
                            <a
                                class="dropdown-item color--red"
                                *appIsPermitted="{
                                    module: 'PARTNERS',
                                    operator: 'AND',
                                    actions: ['DELETE']
                                }"
                                (click)="delete(lane.uuid)"
                                >Delete</a
                            >
                        </div>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="add">
                <ng-container
                    *appIsPermitted="{
                        module: 'PARTNERS',
                        operator: 'AND',
                        actions: ['CREATE']
                    }">
                    <td
                        mat-footer-cell
                        *matFooterCellDef
                        colspan="5"
                        class="table-view__add"
                        (click)="openAddLaneModal()">
                        <i class="las la-plus"></i> Add lane
                    </td>
                </ng-container>
            </ng-container>

            <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns"></tr>

            <tr
                cdkDrag
                mat-row
                *matRowDef="let row; columns: displayedColumns"></tr>
            <!-- An empty table used to show nothing but its headers, which reads as broken rather than empty. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" [attr.colspan]="displayedColumns.length">No results.</td>
            </tr>

            <tr
                mat-footer-row
                *matFooterRowDef="['add']"></tr>
        </table>
    </div>
</div>
